import React from 'react';

export const SubscriptionProcessSkeleton: React.FC = () => {
  return (
    <div className="w-full mt-8 animate-pulse">
      {/* Header Section */}
      <div className="text-center mb-6">
        {/* Title skeleton */}
        <div className="h-8 bg-gray-200 rounded w-80 mx-auto mb-2" />
        {/* Simulation number skeleton */}
        <div className="flex justify-center gap-2">
          <div className="h-5 bg-gray-200 rounded w-40" />
          <div className="h-5 bg-gray-200 rounded w-24" />
        </div>
      </div>

      {/* Steps Section */}
      <div className="flex items-start justify-between w-1/2 mx-auto max-w-screen-md">
        {[1, 2, 3, 4].map((_, index) => (
          <React.Fragment key={index}>
            {/* Step circle and label */}
            <div className="flex flex-col w-3 h-3 relative items-center">
              <div className="w-3 h-3 bg-gray-300 rounded-full" />
              <div className="h-4 bg-gray-200 rounded w-16 mt-4" />
            </div>
            {/* Connector between steps */}
            {index < 3 && (
              <div className="grow border-b-2 border-gray-300 border-dotted mt-[5px]" />
            )}
          </React.Fragment>
        ))}
      </div>

      {/* Content placeholder */}
      <div className="pt-8">
        <div className="w-full max-w-4xl mx-auto">
          <div className="bg-white border rounded-xl p-6">
            <div className="h-6 bg-gray-200 rounded w-48 mb-4" />
            <div className="space-y-3">
              <div className="h-4 bg-gray-200 rounded w-full" />
              <div className="h-4 bg-gray-200 rounded w-3/4" />
              <div className="h-4 bg-gray-200 rounded w-1/2" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
